<div class="login-background">
    <form [formGroup]="loginForm">
        <div class="login-form">
            @if (
                loginFormState === LoginFormState.FillInPassword ||
                loginFormState === LoginFormState.FillIn ||
                loginFormState === LoginFormState.Error ||
                loginFormState === LoginFormState.Login ||
                loginFormState === LoginFormState.MsLogin
            ) {
                <h1 class="h2 condensed">
                    Inloggen met
                    @switch (loginFormState) {
                        @case (LoginFormState.MsLogin) {
                            Microsoft
                        }
                        @case (LoginFormState.FillInPassword) {
                            wachtwoord
                        }
                        @default {
                            code
                        }
                    }
                </h1>
                <mat-form-field id="email" appearance="fill">
                    <input
                        (keydown.enter)="checkLoginType($event)"
                        formControlName="email"
                        matInput
                        name="email"
                        [attr.data-testid]="e2eSelectors.emailInput"
                        placeholder="Vul hier je e-mailadres in"
                        autocomplete="email"
                        type="text" />
                    <mat-label>E-mailadres</mat-label>
                    @if (loginForm.invalid) {
                        <mat-error>Vul een correct e-mailadres in</mat-error>
                    }
                </mat-form-field>
                @if (loginFormState === LoginFormState.FillInPassword) {
                    <mat-form-field id="password" appearance="fill">
                        <mat-label>Wachtwoord</mat-label>
                        <input
                            formControlName="password"
                            autocomplete="current-password"
                            matInput
                            name="password"
                            [attr.data-testid]="e2eSelectors.passwordInput"
                            placeholder="Wat is uw wachtwoord?"
                            type="password" />
                        @if (loginForm.invalid) {
                            <mat-error>Vul uw wachtwoord in</mat-error>
                        }
                    </mat-form-field>
                }
                @if (errorMessage) {
                    <div
                        class="mb-3 pb-1 pt-1 error-background text-center"
                        [attr.data-testid]="e2eSelectors.errorMessage">
                        {{ errorMessage }}
                    </div>
                }
                <div class="login-buttons">
                    <button
                        class="loading big dark"
                        id="btn-login"
                        [attr.data-testid]="e2eSelectors.submitButton"
                        [disabled]="loginFormState === LoginFormState.Login || loginForm.invalid"
                        (click)="login()"
                        color="primary"
                        mat-raised-button>
                        @if (loginFormState === LoginFormState.FillInPassword || loginForm.get('password')?.value) {
                            Inloggen
                        }
                        @if (loginFormState !== LoginFormState.FillInPassword && !loginForm.get('password')?.value) {
                            @if (loginFormState !== LoginFormState.Login) {
                                Opvragen
                            }
                            @if (loginFormState === LoginFormState.Login) {
                                We sturen je nu een code
                                <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                            }
                        }
                    </button>
                    @if (
                        loginFormState !== LoginFormState.FillInPassword &&
                        !loginForm.get('password')?.value &&
                        environment.officePhoneNumber
                    ) {
                        <a [href]="'tel:' + environment.officePhoneNumber" mat-raised-button color="accent">
                            <i class="fa-regular fa-phone"></i> Kantoor
                        </a>
                    }
                    @if (loginFormState === LoginFormState.FillInPassword || loginForm.get('password')?.value) {
                        <button
                            class="me-2"
                            id="btn-lost-password"
                            [attr.data-testid]="e2eSelectors.forgotPasswordButton"
                            (click)="forgotPassword()"
                            mat-button>
                            Wachtwoord vergeten
                        </button>
                    }
                </div>
                <div class="mt-2">
                    <button
                        class="microsoft-login-btn w-100"
                        [class.highlight]="environment.microsoftLoginRequired"
                        (click)="loginWithMicrosoft()"
                        [attr.data-testid]="e2eSelectors.microsoftButton"
                        mat-raised-button>
                        <mat-icon fontSet="fa-brands" fontIcon="fa-microsoft"></mat-icon>
                        Inloggen met Microsoft
                    </button>
                    @if (loginFormState === LoginFormState.MsLogin) {
                        <div class="info">
                            <b>Gebruik "Inloggen met Microsoft"</b>
                            <p>Inloggen met Microsoft is verplicht voor dit e-mailadres.</p>
                        </div>
                    }
                </div>
            }

            @if (loginFormState === LoginFormState.Send || loginFormState === LoginFormState.Validating) {
                <h1>E-mail verstuurd</h1>
                <div class="send mb-2">
                    We hebben een code verstuurd naar <span class="mail">{{ loginForm.value.email }}</span
                    >.<br />
                </div>
                <mat-form-field id="code" appearance="fill">
                    <input
                        [decimalInput]="0"
                        (keyup.enter)="validateCode()"
                        (paste)="pasteCode($event)"
                        appDecimalInput
                        autocomplete="one-time-code"
                        formControlName="code"
                        matInput
                        maxlength="6"
                        name="code"
                        placeholder="Voer de code hier in"
                        type="text" />
                    <mat-label>Code uit e-mail</mat-label>
                </mat-form-field>
                @if (errorMessage) {
                    <div class="mb-3 pb-1 pt-1 error-background text-center">
                        {{ errorMessage }}
                    </div>
                }
                <div class="login-buttons">
                    <button
                        class="loading big dark"
                        id="btn-code"
                        [disabled]="loginFormState === LoginFormState.Validating || loginForm.invalid"
                        (click)="validateCode()"
                        color="primary"
                        mat-raised-button>
                        @if (loginFormState === LoginFormState.Send) {
                            Bevestigen
                        }
                        @if (loginFormState === LoginFormState.Validating) {
                            We controleren je code
                            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                        }
                    </button>
                    @if (environment.officePhoneNumber) {
                        <a [href]="'tel:' + environment.officePhoneNumber" mat-raised-button color="accent">
                            <i class="fa-regular fa-phone"></i> Kantoor
                        </a>
                    }
                </div>
                @if (loginFormState === LoginFormState.Send) {
                    <small class="mt-3 mb-3"> Geen e-mail ontvangen? Controleer je spam </small>
                }
            }
            @if (environment.publicTicketForm) {
                <div class="public-ticket-link">
                    <a routerLink="/melding-indienen" mat-raised-button color="accent">KAM-melding maken</a>
                </div>
            }
        </div>
    </form>
</div>
